import React from 'react';
import { useTranslation } from 'react-i18next';
import {Helmet} from 'react-helmet';

export default function PrivacyPolicy() {
  const { t } = useTranslation();
  const email = 'support@medistime.de';
  const date = 'May 2025';
  const location = 'Germany';

  const renderList = (items) =>
    items.map((item, idx) => <li key={idx}>{item}</li>);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{t('privacyPolicy.title')}</title>
      </Helmet>

    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
      <h1>{t('privacyPolicy.title')}</h1>
      <p>{t('privacyPolicy.updated', { date })}</p>

      {t('privacyPolicy.intro', { returnObjects: true }).map((paragraph, idx) => (
        <p key={idx}>{paragraph}</p>
      ))}

      <h2>{t('privacyPolicy.whoWeAre.title')}</h2>
      <ul>{renderList(t('privacyPolicy.whoWeAre.points', { returnObjects: true }))}</ul>

      <h2>{t('privacyPolicy.dataCollected.title')}</h2>
      <ul>{renderList(t('privacyPolicy.dataCollected.points', { returnObjects: true }))}</ul>

      <h2>{t('privacyPolicy.cookies.title')}</h2>
      <ul>{renderList(t('privacyPolicy.cookies.points', { returnObjects: true }))}</ul>

      <h2>{t('privacyPolicy.whyWeUseData.title')}</h2>
      <ul>{renderList(t('privacyPolicy.whyWeUseData.points', { returnObjects: true }))}</ul>

      <h2>{t('privacyPolicy.protection.title')}</h2>
      <ul>{renderList(t('privacyPolicy.protection.points', { returnObjects: true, location }))}</ul>

      <h2>{t('privacyPolicy.rights.title')}</h2>
      <ul>{renderList(t('privacyPolicy.rights.points', { returnObjects: true }))}</ul>

      <h2>{t('privacyPolicy.contact.title')}</h2>
      <pre>{t('privacyPolicy.contact.info', { email })}</pre>
    </div>
    </>
  );
}
